import { useTranslation } from '@axo/shared/i18n';
import {
  ProgressIndicator,
  ProgressIndicatorLabels,
} from '@axo/ui-core/components/ProgressIndicator';
import { useMemo } from 'react';
import { useAxoFormContext } from '../../context/AxoForm/AxoForm';
import { getStepState } from '../../hooks/useSteps/utils/getStepState';

type FormStepsIndicatorProps = {
  activeStepOnly?: boolean;
};

export const FormStepsIndicator = ({
  activeStepOnly,
}: FormStepsIndicatorProps) => {
  const { t } = useTranslation();
  const { step, steps } = useAxoFormContext();

  const stepsState = useMemo(
    () =>
      steps.map((s, i) => ({
       title: s.customNextStepIndicator
          ? t(s.customNextStepIndicator)
          : t(s.title),
        state: getStepState(i + 1, step),
        hidden: !!s.hidden,
      })),
    [step, steps]
  );

  const labels: ProgressIndicatorLabels = {
    next: t('next'),
    complete: t('submit'),
  };

  return (
    <ProgressIndicator
      step={step}
      steps={stepsState}
      labels={labels}
      activeStepOnly={activeStepOnly}
    />
  );
};
